module.exports = __webpack_public_path__ + "static/headshot-scott-lundgren.259769a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-scott-lundgren.jpg
// module id = 536
// module chunks = 152909308826437